import { ComponentMultiStyleConfig } from '@chakra-ui/react'
import { Z_INDEX } from 'constants/common'

export const Table: Partial<ComponentMultiStyleConfig> = {
  variants: {
    suggestion: {
      thead: {
        '& th': {
          borderBottom: '1px',
          borderColor: 'gray.125',
          zIndex: Z_INDEX.TABLE_HEADER_CELL,
        },
      },
      td: {
        paddingX: '8px',
      },
      th: {
        height: '34px',
        position: 'sticky',
        top: 0,
        background: 'gray.125',
        color: 'gray.550',
        fontSize: 'sm',
        fontWeight: 'medium',
        letterSpacing: 'normal',
        textTransform: 'capitalize',
      },
    },
    simple: {
      thead: {
        '& tr': {
          height: '48px',
        },
        '& th': {
          zIndex: Z_INDEX.TABLE_HEADER_CELL,
        },
      },
      th: {
        position: 'sticky',
        top: 0,
        background: 'product.gray.50',
        color: 'product.text.dark.header',
        fontSize: 'product.sm',
        fontWeight: 'semibold',
        letterSpacing: 'normal',
        textTransform: 'capitalize',
        borderBottom: '1px solid',
        borderColor: 'product.border.subtle',
      },
      td: {
        color: 'gray.800',
        paddingTop: 3,
        paddingBottom: 3,
        border: 'none',
        height: '64px',
      },
      tbody: {
        '& > tr': {
          '&:hover': {
            backgroundColor: 'product.table.hover',
          },
        },
      },
    },
    // This exists to not break the existing table styles, since table-layout: fixed in combination with the huge colspan in `src/components/Table/TableBody.tsx` breaks the table layout.
    dataTable: {
      table: {
        tableLayout: 'fixed',
        borderCollapse: 'separate',
        borderSpacing: 0,
        width: 'full',
        bg: 'white',
      },
      thead: {
        '& tr': {
          height: '48px',
        },
        '& th': {
          zIndex: Z_INDEX.TABLE_HEADER_CELL,
        },
      },
      th: {
        background: 'product.gray.50',
        color: 'product.text.dark.header',
        fontSize: 'product.sm',
        fontWeight: 'semibold',
        letterSpacing: 'normal',
        textTransform: 'capitalize',
        borderBottom: '1px solid',
        borderColor: 'product.border.subtle',
      },
      td: {
        color: 'gray.800',
        paddingTop: 3,
        paddingBottom: 3,
        border: 'none',
        height: '64px',
      },
    },
    dummy: {
      table: {
        backgroundColor: 'white',
      },
      th: {
        height: '52px',
        backgroundColor: 'blueGray.404',
        textTransform: 'capitalize',
        borderBottom: '0',
      },
      td: {
        paddingY: 0,
        borderBottom: '1px',
        borderColor: 'blueGray.403',
      },
      tr: {
        height: '50px',
      },
    },
    light: {
      thead: {
        '& tr': {
          height: '50px',
        },
        '& th': {
          zIndex: Z_INDEX.TABLE_HEADER_CELL,
        },
      },
      th: {
        position: 'sticky',
        top: 0,
        background: 'white',
        color: 'gray.800',
        fontSize: 'sm',
        fontWeight: 'medium',
        letterSpacing: 'normal',
        textTransform: 'capitalize',
        cursor: 'default',
      },
      td: {
        borderTop: '1px',
        borderColor: 'blueGray.200',
        color: 'gray.800',
      },
      tr: {
        '&[aria-selected="true"]': {
          td: {
            bg: 'royalBlue.50',
          },
        },
      },
    },
    product: {
      thead: {
        borderRadius: '2xl',
        bg: 'product.gray.50',
        color: 'product.text.dark.header',
        h: 12,
        textTransform: 'capitalize',
        '& tr': {
          borderBottomWidth: '1px',
          borderBottomColor: 'product.border.solid',
        },
        '& th, & th > button': {
          textTransform: 'capitalize',
          fontSize: 'sm',
          fontWeight: 'semibold',
        },
      },
      tbody: {
        '& > tr': {
          borderTopWidth: '1px',
          borderTopColor: 'product.border.solid',
        },
        '& > td ': { py: 3 },
        bg: 'white',
        color: 'product.text.dark.bodySolid',
        fontSize: 'sm',
      },
    },
  },
}
